import React from 'react'
import SALink from 'components/SALink'
import HelpIcon from 'svg/help.svg'
import ArtistNewsletterIcon from 'svg/artist-newsletter.svg'
import TipsIcon from 'svg/tips.svg'
import {
  SUPPORT_REQUEST_LINK,
  ARTIST_NEWSLETTER_LINK,
  ARTIST_HANDBOOK_LINK,
  CANVAS_LINK,
} from '../helpers/constants'
import Button from './MainButton'

const Component = (): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <div data-type='support'>
      <p data-type='title'>Dedicated Artist Support</p>
      <div data-type='item-row'>
        <div data-type='item'>
          <HelpIcon />
          <p data-type='sub-title'>Here to Help</p>
          <p data-type='text'>
            Work with an artist support specialist by{' '}
            <a
              data-type='link'
              target='_blank'
              rel='noopener noreferrer'
              href={SUPPORT_REQUEST_LINK}
            >
              email
            </a>{' '}
            or phone when you have a question, or need assistance fulfilling a sale.
          </p>
        </div>
        <div data-type='item'>
          <ArtistNewsletterIcon />
          <p data-type='sub-title'>Artist Newsletters</p>
          <p data-type='text'>
            Sign up for our{' '}
            <SALink
              data-type='link'
              target='_blank'
              rel='noopener noreferrer'
              href={ARTIST_NEWSLETTER_LINK}
            >
              artist newsletter
            </SALink>{' '}
            and get helpful tips for improving your sales delivered straight to your inbox.
          </p>
        </div>
        <div data-type='item'>
          <TipsIcon />
          <p data-type='sub-title'>Tips for Success</p>
          <p data-type='text'>
            Best practices, new opportunities for promotion and general inspiration in our{' '}
            <a
              data-type='link'
              target='_blank'
              rel='noopener noreferrer'
              href={ARTIST_HANDBOOK_LINK}
            >
              Artist Handbook
            </a>{' '}
            and on the{' '}
            <a data-type='link' target='_blank' rel='noopener noreferrer' href={CANVAS_LINK}>
              Canvas
            </a>{' '}
            blog.
          </p>
        </div>
      </div>
      <Button dataStyle='support-button' modalName='from-support' />
    </div>
  )
}

export default Component